import { render, staticRenderFns } from "./bo-coupon-list.vue?vue&type=template&id=31a99dc0"
import script from "./bo-coupon-list.vue?vue&type=script&lang=js"
export * from "./bo-coupon-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports